import BinaryIndexedTree from "./BinaryIndexedTree";

export default BinaryIndexedTree;
